// extracted by mini-css-extract-plugin
export default {"banner":"hjPPYAJrkJbjevs4eFqL"};